module.exports = "### OpenSource \n\n- React decoupled from the Facebook codebase\n\n- Driving force behind open sourcing\n\n- 3rd most starred project on GitHub\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_9.md
// module id = 1490
// module chunks = 0